import { Button, Card, Group, Image, MantineTheme, Stack, Text, Title } from "@mantine/core";
import { Entity, EntityDefinition, getGoogleMapsStreetViewImage, latLng, RecordGroupManager, useEntityUI, ValuesRecord } from "@mcurros2/microm";
import { Dashboard } from "./Dashboard";

export function CheckoutVisitasPersonalViewInfoWindowRenderer(
    record: ValuesRecord,
    position: latLng,
    groupManager: RecordGroupManager,
    infoWindow: google.maps.InfoWindow,
    UIAPI: ReturnType<typeof useEntityUI>,
    theme: MantineTheme,
    entity: Entity<EntityDefinition>
) {
    const dashboard = entity as Dashboard;

    const cadena = record[1] as string;
    const tienda = record[2] as string;
    const domicilio = record[3] as string;
    const diferencia = record[8] as string;

    const image_src = getGoogleMapsStreetViewImage(position, 350, 200, 150);

    const group = groupManager.getGroupByLocation(position);

    if (group) {
        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    <Image width={350} height={120} src={image_src} mx="auto" />
                    {group.records.map(
                        ({ recordValue: rec }, index) => {
                            const g_tienda_id = rec[2] as string;
                            
                            return (<Stack key={`grp_${g_tienda_id}`}>
                                <Title order={5}>{index + 1}: {g_tienda_id}</Title>
                            </Stack>)
                        }
                    )
                    }
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
    else {

        return (
            <Card withBorder padding="xs">
                <Stack spacing="0.5rem">
                    <Image width={350} height={120} src={image_src} mx="auto" />
                    <Title order={4}>{`${tienda}`}</Title>
                    <Group spacing="xs">
                        <Text weight={500} size="sm">
                            {cadena} - {tienda} - {domicilio} - Distancia a tienda: {diferencia}m
                        </Text>    
                    </Group>
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
}